import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

export default function Search({ value, onChange, count }) {
  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
      <InputGroup style={{ maxWidth: '400px' }} className="bg-light rounded-2 overflow-hidden border">
        <InputGroup.Text className="bg-transparent border-0 pe-0 text-muted">
          <i className="bi bi-search"></i>
        </InputGroup.Text>
        <Form.Control 
          placeholder="Поиск по названию..." 
          className="bg-transparent border-0 py-2 shadow-none"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </InputGroup>
      
      <div className="text-muted small fw-medium">
        Найдено услуг: <span className="text-dark fw-bold">{count}</span>
      </div>
    </div>
  );
}
